import React, { PropTypes, Component } from 'react'
import { Link } from 'react-router-dom';
import SectionTitle from '../../resorthome/sectiontitle';
import withPage from '../../../containers/withpage';
import NewsList from '../../news/list';
import style from './style.css'


class News extends Component {

    render() {
        const { news } = this.props
        return (
            <div className={ style.news }>
              <SectionTitle title="أحدث المقالات" subtitle="تصفح المزيد" link="/"/>
                <NewsList count="10" slug="news"/>
            </div>
        )
    }
}

export default News



// WEBPACK FOOTER //
// ./src/components/homescreen/news/index.js